module.exports = {"Tesla":{"regex":"(?:Tesla/[0-9.]+|QtCarBrowser)","device":"car browser","models":[{"regex":"QtCarBrowser","model":"Model S"},{"regex":"Tesla/[0-9.]+","model":""}]}}


//////////////////
// WEBPACK FOOTER
// ./~/device-detector-js/dist/fixtures/regexes/device/car_browsers.json
// module id = 1532
// module chunks = 13 14